module.exports = __webpack_public_path__ + "static/discover-logo-small-3b404c41a8f50418c2df1f98a1873be5.svg";